import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { ProductSummaries } from "./summaries.type";

export type GetSummariesParams = {
  chameleonRequestInstance: ChameleonRequest;
  productIds: number | number[];
  store: string;
  keyStoreDataversion: string;
  expand: Array<"variants">;
  lang: string;
  shop: string;
  currency: string;
  sizeSchema: string;
};

export const getSummaries = async (props: GetSummariesParams) => {
  const { chameleonRequestInstance, productIds, ...searchParams } = props;

  const url = getApiUrl({
    path: `/product/catalogue/v4/summaries/`,
    searchParams: {
      ...searchParams,
      productIds: Array.isArray(productIds) ? productIds : [productIds],
    },
  });

  try {
    const response = await chameleonRequestInstance.get<ProductSummaries[]>(
      url,
      undefined,
      {
        requestType: "SUMMARIES_API",
      },
    );

    return response.data || null;
  } catch (error) {
    console.error(error);
  }
};
